import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import type { TIrrigationActivityForPointOrZone } from 'App/Map/CurrentValuesMap/caches/StationValuesCache/StationValuesCache'
import { colors } from 'settings/colors'
import type { TIrrigationZoneEmitterId } from 'stores/fieldAssetStore/helperTypes'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import { minutesToHoursAndMinutesAlwaysShowingHours } from 'utils/minutesToHoursAndMinutesAlwaysShowingHours'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import { EmitterStatus } from '../components/EmitterStatus'

const MILLISECONDS_IN_MINUTE = 1000 * 60

export const formatEmitterData = (
  entry: [string, TIrrigationActivityForPointOrZone[string]],
  valueTypeIsForStatus: boolean,
): {
  id: string
  emitter: JSX.Element
  duration: JSX.Element
  applied: JSX.Element
} => {
  const [irrigationZoneEmitterId, { getBadgeColors, flowRate, applied, duration, status }] = entry

  const { emitterType } = getIdAndEmitterTypeFromZoneEmitterTypeKey(
    irrigationZoneEmitterId as TIrrigationZoneEmitterId,
  )

  const applicationRate =
    !valueTypeIsForStatus && flowRate?.mmPerHour
      ? `${unitConverter.irrigationActivity(flowRate?.mmPerHour, { decimalPlaces: 3 }).valueWithSuffix()}/hr`
      : ''

  const appliedValue = unitConverter.irrigationActivity(!applied || isNaN(applied) ? 0 : applied)

  return {
    id: irrigationZoneEmitterId,
    emitter: (
      <div
        css={{
          display: 'flex',
          gap: 5,
          alignItems: 'center',
        }}
      >
        <div
          css={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <EmitterStatus status={status} />
        </div>
        <div>
          {mapApiEmitterTypeToLabel(emitterType)}
          <div css={{ fontSize: 10, opacity: 0.6 }}>{applicationRate}</div>
        </div>
      </div>
    ),
    duration: !valueTypeIsForStatus ? (
      <div css={{ colors: colors.midnight, fontWeight: 700 }}>
        {minutesToHoursAndMinutesAlwaysShowingHours(duration ? duration / MILLISECONDS_IN_MINUTE : 0)}
      </div>
    ) : (
      <div />
    ),
    applied: !valueTypeIsForStatus ? (
      <div css={{ display: 'flex', gap: 5, alignItems: 'center' }}>
        <div
          css={{
            color: getBadgeColors().color,
            backgroundColor: getBadgeColors().backgroundColor,
            padding: '4px 8px',
            borderRadius: 5,
            fontWeight: 700,
          }}
        >
          {appliedValue.value()}
        </div>
        <div css={{ opacity: 0.8 }}>{appliedValue.suffix()}</div>
      </div>
    ) : (
      <div />
    ),
  }
}
